import {getEnvironment} from '@sail/utils';
import {DEFAULT_LOCALE, DEFAULT_LOCALE_DATA} from 'src/internal/constants';
import {IntlMissingLocaleData} from 'src/internal/errors';

import type {IReports} from '@sail/observability';
import type {IntlConfig, Locale, LocaleData} from 'src/types';

export default function getLocaleData(
  requestedLocale: Locale,
  config: IntlConfig,
  reports: IReports,
): LocaleData {
  const {localeData} = config;

  if (requestedLocale === DEFAULT_LOCALE) {
    return DEFAULT_LOCALE_DATA;
  }

  if (!localeData || localeData?.locale !== requestedLocale) {
    const error = new IntlMissingLocaleData(requestedLocale);

    reports.error(error, {project: 'sail_core'});

    if (getEnvironment() !== 'production') {
      throw error;
    }

    return DEFAULT_LOCALE_DATA;
  }

  return localeData;
}
